import {
  queryOptions,
  useQuery,
  useSuspenseQuery,
} from "@tanstack/react-query";
import { API } from "../api";

export const advanceVenueSubmissionQueryOptions = (id: string) =>
  queryOptions({
    queryKey: ["advanceVenueSubmission", id],
    queryFn: async () => {
      const response =
        await API.venueFormSubmissions.venueFormSubmissionsControllerFindOne(
          id
        );
      return response.data;
    },
    enabled: !!id,
  });

export const useAdvanceVenueSubmission = (id: string) => {
  return useQuery(advanceVenueSubmissionQueryOptions(id));
};

export const useAdvanceVenueSubmissionSuspense = (id: string) => {
  return useSuspenseQuery(advanceVenueSubmissionQueryOptions(id));
};
